import './CustomComponent.scss';
import { CustomComponentTypes } from '@models/Forms/CustomComponentTypes';
import WinnerSelectionTableDemand from './components/WinnerSelection/WinnerSelectionTableDemand/WinnerSelectionTableDemand';
import WinnerSelectionTablePositions from './components/WinnerSelection/WinnerSelectionTablePositions/WinnerSelectionTablePositions';
import WinnerSelectionTableKO from './components/WinnerSelection/WinnerSelectionTableKO/WinnerSelectionTableKO';
import SupplyScheduleTable from './components/SupplySchedule/SupplyScheduleTable/SupplyScheduleTable';
import WinnerSelection2 from './components/WinnerSelection2/WinnerSelection2';
import { ICustomComponentProps } from './ICustomComponentProps';
import { useContext } from 'react';
import { DocumentRuntimeContext } from '@/context/DocumentRuntimeContext';
import { getCustomComponentPreviewDescriptor } from './customComponentPreviewRegistry';

const CustomComponent = <TFieldValues extends object = object>({ ...props }: ICustomComponentProps<TFieldValues>) => {
    const runtime = useContext(DocumentRuntimeContext);

    if (runtime.mode === 'supportPreview') {
        const previewDescriptor = getCustomComponentPreviewDescriptor(props.component.type);
        const componentIdentity = props.component.id || 'без id';
        const tableKey = props.component.params?.tableKey;

        return (
            <div
                className="custom-component custom-component--preview-unsupported"
                data-testid={props.component.id ? `custom-component-${props.component.id}` : undefined}
                data-preview-blocker={previewDescriptor.blocker}
                role="note"
            >
                <b>{previewDescriptor.displayName}: preview недоступен</b>
                <span>{previewDescriptor.reason} Actor API не вызывается.</span>
                <small>
                    ID: {componentIdentity} · type: {props.component.type}
                    {tableKey && ` · tableKey: ${tableKey}`}
                    {previewDescriptor.blockedServices.length > 0 &&
                        ` · заблокировано: ${previewDescriptor.blockedServices.join(', ')}`}
                </small>
            </div>
        );
    }

    const renderComponent = () => {
        switch (props.component.type) {
            case CustomComponentTypes.Unknown:
                return 'Неизвестный тип компонента';
            case CustomComponentTypes.WinnerSelectionTableDemand:
                return <WinnerSelectionTableDemand {...props} />;
            case CustomComponentTypes.WinnerSelectionTableLot:
                return 'Кастомное представление выбора победителя. Полотовое представление';
            case CustomComponentTypes.WinnerSelectionTablePositions:
                return <WinnerSelectionTablePositions {...props} />;
            case CustomComponentTypes.WinnerSelectionTableMixed:
                return 'Кастомное представление выбора победителя. Смешанное представление';
            case CustomComponentTypes.WinnerSelectionTableKO:
                return <WinnerSelectionTableKO {...props} />;
            case CustomComponentTypes.SupplyScheduleTable:
                return <SupplyScheduleTable {...props} />;
            case CustomComponentTypes.WinnerSelection2:
                return <WinnerSelection2 {...props} />;
            default:
                return 'Неизвестный тип компонента';
        }
    };

    return (
        <div
            className={'custom-component'}
            data-testid={props.component.id ? `custom-component-${props.component.id}` : undefined}
        >
            {renderComponent()}
        </div>
    );
};

export default CustomComponent;
